import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const CircleArrowRight = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24 12C24 5.37223 18.6278 0 12 0C5.37223 0 0 5.37223 0 12C0 14.0378 0.509462 16.0048 1.46688 17.7541C2.20267 19.0974 3.19065 20.2896 4.37369 21.266C6.5074 23.0226 9.17991 24 12 24C18.6278 24 24 18.6278 24 12ZM1.1999 12C1.1999 6.03497 6.03487 1.2 11.9999 1.2C17.9649 1.2 22.7999 6.03497 22.7999 12C22.7999 17.965 17.9649 22.8 11.9999 22.8C9.46077 22.8 7.05719 21.921 5.13686 20.34C4.07155 19.4608 3.18165 18.3869 2.51933 17.1778C1.65809 15.6043 1.1999 13.8352 1.1999 12Z'
      />
      <path
        d='M14.9102 12L9.68331 17.4878C9.57177 17.6049 9.5717 17.7948 9.68314 17.912C9.79459 18.0292 9.97536 18.0293 10.0869 17.9122L15.5159 12.2122C15.6275 12.095 15.6275 11.905 15.5159 11.7878L10.0869 6.08778C9.97536 5.97067 9.79459 5.97075 9.68314 6.08796C9.5717 6.20516 9.57177 6.39511 9.68331 6.51222L14.9102 12Z'
        stroke='#3FA110'
        strokeWidth='0.5'
      />
    </svg>
  )
}
